import client from "services/ngage/api-client";
import DataResource from "types/DataResource";
import {snakeKeys} from "services/array";
import deserializeConversation from "./deserializers/conversation";
import {Conversation, ConversationData} from "../../types/Conversation";

export type ConversationFilters = {
    search?: string | null
    page?: number
    per_page?: number
}

/**
 * Get all conversations (paginated)
 */
const filtered = async (filters: ConversationFilters = {}) => {
    const params = Object.assign({page: 1, per_page: 100}, snakeKeys(filters))
    const response = await client.get<DataResource<Conversation>>('/conversations', {params})

    if (response.data) {
        response.data.data = response.data.data.map(deserializeConversation)
    }

    return response.data
}

/**
 * Get a single conversation
 *
 * @param {number} id
 */
const get = async (id: number) => {
    // TODO: Remove per_page param
    const response = await client.get<Conversation | null>(`/conversations/${id}`, { params: {per_page: 1000} })
    return response.data ? deserializeConversation(response.data) : null
}

/**
 * Store a new conversation
 *
 * @param data
 */
const store = async (data: ConversationData) => {
    const response = await client.post<Conversation | null>('/conversations', data)
    return response.data ? deserializeConversation(response.data) : null
}

/**
 * Update an existing conversation
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: ConversationData) => {
    const response = await client.post<Conversation | null>(`/conversations/${id}`, data)
    return response.data ? deserializeConversation(response.data) : null
}

/**
 * Permanently delete a conversation
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/conversations/${id}`)
    return response.status === 204
}

const conversations = {
    filtered,
    get,
    store,
    update,
    destroy
}

export default conversations;